// Talep 768.4 / 769.1 / 770.1-2 / 771.2 — "Kaydettim ama tanımı açtığımda alanlar boş geliyor".
//
// KÖK NEDEN (sistemik, ~41 detay ekranında aynı desen):
// Liste sayfaları OData `$select`'i **yalnız GÖRÜNÜR kolonlardan** üretir (bkz.
// `buildSelectFields`, VendorsPage.js:197). Listeden bir satıra tıklandığında o kısmi satır
// `navigate(..., { state: { row } })` ile detay ekranına taşınır ve detay formu DOĞRUDAN
// ondan doldurulur. Projeksiyonda olmayan her alan (İlgili Kişi, Adres, TC, Vergi No,
// Posta Kodu, Bölge 1/2, Para Birimi, Açıklama, Konum, Dağıtıcı, kriterler…) forma boş
// girer — kayıt aslında DB'de dolu olduğu hâlde kullanıcı "kaydedilmemiş" görür.
//
// Ekranlar zaten arka planda `GetById` çağırıyordu ama dönen tam kaydı SADECE audit
// (oluşturan/güncelleyen) için kullanıyordu; forma yazmıyordu. Bu hook onu forma da yazar.
//
// Kullanıcının yazdığını ezmemek için: yanıt geldiğinde form "kirli" ise (kullanıcı bir
// alana dokunmuşsa) tazeleme ATLANIR. Detay ekranları varsayılan olarak salt-okunur
// açıldığından (#282) pratikte yarış oluşmaz; bu yalnız güvenlik ağıdır.
import { useCallback, useRef } from 'react';

/**
 * @returns {{
 *   markDirty: () => void,          // form değişiminde çağır (set sarmalayıcısı)
 *   refillIfClean: (apply: () => void) => void, // tam kayıt geldiğinde forma yaz
 *   isDirty: () => boolean,
 * }}
 */
export function useFullRecordRefill() {
  const dirtyRef = useRef(false);

  const markDirty = useCallback(() => { dirtyRef.current = true; }, []);
  const isDirty = useCallback(() => dirtyRef.current, []);
  const refillIfClean = useCallback((apply) => {
    if (dirtyRef.current) return;
    apply();
  }, []);

  return { markDirty, refillIfClean, isDirty };
}

export default useFullRecordRefill;
